export default "__VITE_ASSET__CWmjzHRB__"